import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { getBrand, getBrandConfig, getEnvironment, initializeSentry } from '@shared/services';

import packageInfo from '../package.json';
import { PortalClientAppComponent } from './app/portal-client-app.component';
import { appConfig } from './app/portal-client-app.config';

initializeSentry('rocket-portal@' + packageInfo.version);

// Apply host-based branding before bootstrap to avoid a flash of the wrong theme.
const brandConfig = getBrandConfig();
document.documentElement.setAttribute('data-brand', getBrand());
document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', brandConfig.favicon);
document.title = `Portal - ${brandConfig.displayName}`;

if (getEnvironment().production) {
  enableProdMode();
}

bootstrapApplication(PortalClientAppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch(
  (err) => console.error(err),
);
